// Dependencies
import React, { Fragment, FunctionComponent } from 'react'

// Components
import { Icon } from 'component-library/icon'

// Styles
import {
  NavbarButtonsWrapper,
  NavbarContent,
  NavbarContainer,
  NavItemContainer,
  NavListContainer,
  NavbarLogo,
  FloatContainerCloseIconWrapper
} from './navbar.styles'

// Types
import { NavbarProps, NavItemProps, NavListProps } from './navbar.types'

// Assets
import logo from './assets/proenem.svg'
import { NavbarButton } from 'component-library/navbar-button'
import { ConditionallyRender } from 'component-library/conditionally-render'
import { FloatContainer } from 'component-library/float-container/float-container'

export const Navbar: FunctionComponent<NavbarProps> = ({
  navOptionsCompositions,
  isFloatContainerOpened,
  floatContainerComposition,
  handleFloatContainerClick,
  handleLogoNavigate
}) => {
  return (
    <NavbarContainer>
      <NavbarContent>
        <NavbarLogo src={logo} onClick={handleLogoNavigate} />

        <div className="wrapper">
          <ConditionallyRender
            minimumBreakpoint="tablet"
            shouldRender={!!navOptionsCompositions}
            content={
              <div className="nav-list-wrapper">
                <NavList content={navOptionsCompositions} />
              </div>
            }
          />

          <ConditionallyRender
            maximumBreakpoint="tablet"
            content={
              <NavbarButton
                className="menu"
                variant="primary"
                borderType="medium"
                handleClick={handleFloatContainerClick}
                iconElement={<Icon name="user" color="#fff" size={24} />}
              />
            }
          />
        </div>
      </NavbarContent>

      {!!isFloatContainerOpened && (
        <FloatContainer
          headerComposition={
            <FloatContainerCloseIconWrapper onClick={handleFloatContainerClick}>
              <Icon name="close" size={24} color="#3A3E47" />
            </FloatContainerCloseIconWrapper>
          }
          content={floatContainerComposition}
        />
      )}
    </NavbarContainer>
  )
}

export const NavItem: FunctionComponent<NavItemProps> = ({
  label,
  handleClick
}) => {
  return (
    <NavItemContainer className="sisu-navitem" onClick={handleClick}>
      {label}
    </NavItemContainer>
  )
}

export const NavList: FunctionComponent<NavListProps> = ({
  direction,
  content
}) => {
  return <NavListContainer direction={direction}>{content}</NavListContainer>
}
